// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/slider/style/index.less
// module id = 1427
// module chunks = 0